module.exports = __webpack_public_path__ + "img/Cubs_220917_23 (2).d996deeb.png";